jQuery(document).ready(function ($) {
  $('.clickable-image').off('click');
  $('.clickable-image').click(function (e) {
    e.preventDefault();
    if ($(this).attr('data-clickable').value != '') {
      window.open($(this).data('clickable'), '_blank');
    }
  });
});
